import React from 'react';
import BridgeMain from './Components/BridgeMain';

const App: React.FC = () => {
  return (
    <BridgeMain />
  );
};

export default App;